export default __webpack_public_path__ + "static/assets/3a10385fdc6a89176bd1db81a1a91afa.png";